module.exports = __webpack_public_path__ + "img/complete.fa7406ed.png";